// extracted by mini-css-extract-plugin
module.exports = {"dialog":"addAccountModal_dialog__1Dus7","text":"addAccountModal_text__2y2RP","buttonWrapper":"addAccountModal_buttonWrapper__2GFl9"};